import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dvla-vin',
    templateUrl: './dvla-vin.component.html',
    styleUrls: ['./dvla-vin.component.scss'],
    standalone: false
})
export class DvlaVinComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
